import { useState, useEffect, Fragment } from 'react';

import Money from '../Parts/Money';

import { useTotalAdditionalMotorsPrice, useIsShowingMyPrice } from '../hooks';

// TODO: Delete unused values

/* eslint-disable camelcase */
const TotalPrice = ({
	quoteTotals, printTotals, quote, moneyFunctions, isPrint, className
}) => {
	const [outsideContinentalUS, setOutsideContinentalUS] = useState(false);
	const [quoteTotalsy, setQuoteTotals] = useState(quoteTotals);
	const [localPrintTotals, setLocalPrintTotals] = useState(printTotals);

	const localQuoteTotals = isPrint && localPrintTotals ? localPrintTotals : quoteTotalsy;

	const show_my_price = useIsShowingMyPrice(quote);

	const total_additional_motors_price = useTotalAdditionalMotorsPrice(quote);

	const pricing_data = {};

	let total_indoor_shades_shipping_fees = pricing_data.indoor_shades_shipping_fees_price;
	let total_indoor_shades_shipping_price = pricing_data.indoor_shades_shipping_price;

	const { money } = pricing_data;

	const pricingAs = quote.pricing_as.includes("My Price");

	if (money) {
		if (money.buy_currency !== money.sell_currency
			&& !pricingAs) {
			total_indoor_shades_shipping_fees *= money.multiplier;
		}

		if (money.buy_currency !== money.sell_currency
			&& pricingAs) {
			total_indoor_shades_shipping_price /= money.multiplier;
		}
	}
	const total_outdoor_shades_shipping_price = pricing_data.outdoor_shades_shipping_fees_price;

	useEffect(() => {
		moneyFunctions.setQuoteTotals = moneyFunctions.setQuoteTotals
			? [setQuoteTotals, ...moneyFunctions.setQuoteTotals]
			: [setQuoteTotals];
		moneyFunctions.setPrintTotals = moneyFunctions.setPrintTotals
			? [setLocalPrintTotals, ...moneyFunctions.setPrintTotals]
			: [setLocalPrintTotals];

		api.getTerritoryInfo(quote.territory_id)
			.then((terr) => {moneyFunctions
				if (terr && !terr.within_continental_usa) {
					setOutsideContinentalUS(true);
				}
			});
	}, []);

	const PriceRow = ({ children, no_hr }) => (

		<>
			<span style={{
				textAlign: 'right', display: 'inline-block', width: '100%'
			}}
			>
				{children}
			</span>
			{no_hr ? null : <hr />}
		</>
	);

	const hasErrors = () => {
		const has_missing_msrps =
			pricing_data && pricing_data.shade_assemblies
				? pricing_data.shade_assemblies.some((sa) => parseFloat(sa.total_msrp) < 1)
				: false;

		const error_shade_count = quote.shades.filter((shade) =>
			shade.options().some((opt) => opt.error && opt.error(shade))).length;

		return has_missing_msrps || (error_shade_count > 0 && !quote.is_order);
	};

	const shades_total = show_my_price
		? pricing_data.shade_assemblies_total_my_price
		: pricing_data.shade_assemblies_total_msrp;
	const accessories_total = show_my_price
		? pricing_data.accessories_total_my_price
		: pricing_data.accessories_total_msrp;
	let accessories_total_shipping = pricing_data.accessories_total_shipping_price;

	let currency = "";

	if (money) {
		if (money.buy_currency !== money.sell_currency
			&& pricingAs) {
			accessories_total_shipping /= money.multiplier;
		}

		currency = `(${pricingAs ? money.buy_currency : money.sell_currency})`;
	}

	const {
		accessoryDisplay,
		accessoryShipping,
		shadePrice,
		indoorShadeShipping,
		outdoorOutsideContinental,
		couponTotal,
		overSizedShipping,
		total,
		hasOutdoorShade,
		hasError,
		taxes,
		subtotal,
		outdoorShadeShipping,
		preCoupon,
		taxMessage,
		hardwareParts,
		hardwarePartsShipping,
		paidPrice,
		name,
	} = localQuoteTotals;

	if (hasError) {
		return (

			<div style={{ textAlign: 'right' }}>
				Please correct all shade errors.
			</div>
		);
	}

	const shipping = indoorShadeShipping + accessoryShipping + outdoorShadeShipping + hardwarePartsShipping;

	const shippingTitle = `Shipping Total`;

	const taxDisplay = [];
	let index = 0;
	if (taxMessage) {
		taxMessage.split('<br>').forEach((element) => {
			index++;
			taxDisplay.push(<Fragment key={`k-${index}`}>{element}</Fragment>);
			index++;
			taxDisplay.push(<br key={`k-${index}`} />);
		});
	}

	const { symbol } = localQuoteTotals;

	return (

		<>
			<div key="01" className={className} style={{ width: '100%' }}>

				{accessoryDisplay > 0

					? (
						<PriceRow key="PR1">
						Accessories:
							{' '}
							<Money symbol={symbol}>{accessoryDisplay}</Money>
						</PriceRow>
					)
					: null}

				{false

					? (
						<PriceRow key="PR2">
						Additional Motors:
							{' '}
							<Money symbol={symbol}>{total_additional_motors_price}</Money>
						</PriceRow>
					)
					: null}

				{shadePrice > 0

					? (
						<PriceRow key="PR3">
							{quote.getShadeCount()}
							{' '}
							{quote.getShadeCount() == 1 ? 'Shade' : 'Shades'}
:
							{' '}
							<Money symbol={symbol}>{shadePrice}</Money>
						</PriceRow>
					)
					: null}
				{hardwareParts > 0

					? (
						<PriceRow key="HW">
						Hardware Parts
							{' '}
							<Money symbol={symbol}>{hardwareParts}</Money>
						</PriceRow>
					)
					: null}

				{shipping > 0

					? (
						<PriceRow key="PR4">
							{shippingTitle}
:
							<Money symbol={symbol}>{shipping}</Money>
						</PriceRow>
					)
					: null}

				{overSizedShipping > 0

					? (
						<PriceRow key="PR5">
						**Oversized Freight:
							{' '}
							<Money symbol={symbol}>{overSizedShipping}</Money>
						</PriceRow>
					)
					: null}

				{outdoorOutsideContinental && hasOutdoorShade
					? (
						<PriceRow key="PR6">
						*Outdoor Shades Freight:
						</PriceRow>
					)
					:					null}

				{taxes > 0
					? (
						<>
							<PriceRow key="PR7">
							Subtotal:
								{' '}
								<Money symbol={symbol}>{subtotal}</Money>
							</PriceRow>
							<PriceRow key="PR8">
							***Taxes:
								{' '}
								<Money symbol={symbol}>{taxes}</Money>
							</PriceRow>
						</>
					)
					: null}

				{ (couponTotal ?? 0) > 0
					? (
						<>
							<PriceRow key="PR7">
							Before Coupon:
								{' '}
								<Money symbol={symbol}>{preCoupon}</Money>
							</PriceRow>
							<PriceRow key="PR8">
							Coupon: -
								<Money symbol={symbol}>{couponTotal}</Money>
							</PriceRow>
						</>
					)
					: null}

				<PriceRow no_hr key="PR9">
					{`(${localQuoteTotals.ISO})`}
					{' '}
Total:
					<Money symbol={symbol}>{total || null}</Money>
				</PriceRow>

			</div>
			<div key="02" style={{ width: '100%' }}>
				{
					outdoorOutsideContinental && hasOutdoorShade

						? (
							<div key="PN1">
								<span st yle={{ fontSize: '13px', marginTop: '1em' }}>
* Shipping charges for outdoor shades will be invoiced
									<br />
&nbsp;&nbsp;separately for orders outside the continental U.S.
									<br />
									<br />
								</span>
							</div>
						)
						:						null
				}

				{
					overSizedShipping > 0
						? (
							<div key="PN2">
								<span style={{
									fontSize: '13px', display: 'inline-block', marginTop: '1em', alignContent: 'right'
								}}
								>
								**All freight prices are standard Ground shipping.
									<br />
									<br />
				Requested Expedited shipping or additional services
									{' '}
									<br />
(Lift-gate, Residential Delivery, White glove delivery, etc…)
									{' '}
									<br />
				will be charged actual invoice, and will be charged
									{' '}
									<br />
before shipment if not selected during the
									{' '}
									<br />
									{' '}
"Place Order" order process..
									<br />
									<br />
				If you suspect Freight Damage, REFUSE the shipment.
									{' '}
									<br />
The product will be returned to PowerShades
									{' '}
									<br />
									{' '}
for expedited repair or replacement.
									<br />
									<br />
				Freight Damage must be reported within 10 days of
									{' '}
									<br />
receipt of goods. Contact Customer service immediately,
									<br />
									{' '}
and retain all packaging.
									{' '}
									<br />
				The product will be returned to PowerShades for expedited
									<br />
									{' '}
repair or replacement.
									<br />
									<br />
								</span>
							</div>
						)
						:						null
				}
				{
					taxes
						? taxMessage ? (
							<div key="1k">
								<span style={{
									fontSize: '13px', display: 'inline-block', marginTop: '1em', alignContent: 'right'
								}}
								>
								***
									{taxDisplay}
								</span>
							</div>
						)
							: (
								<div key="2k">
									<span style={{
										fontSize: '13px', display: 'inline-block', marginTop: '1em', alignContent: 'right'
									}}
									>
									***
										{`This quote was taxed at ${quote.taxRate * 100}%. Unlock Quote for a Tax Explanation. `}
									</span>
								</div>
							) : null
				}

			</div>
		</>
	);
};

export default TotalPrice;
